import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useOffer from "../../api/hooks/useOffers";
import { logMsgBgColors } from "../../consts/misc";
import { toIcons } from "../../consts/Paths";
import MainContext from "../../context/MainContext";
import useIsMobile from "../../hooks/useIsMobile";
import useToggle from "../../hooks/useToggle";
import { Model } from "../../interfaces";
import { offerRemappingFromResult } from "../../utils/offerRemapping";

const ModelCard = (props: any) => {
  const navigate = useNavigate();
  const { isMobile } = useIsMobile();
  const isIconShowUp = useToggle(false);

  const { setModel, modelSelector, token, offer, setOffer } =
    useContext(MainContext);
  const { onModelSelection, modelList, setModelList } = modelSelector;
  const { RESPONSES, RESULTS, CTAs } = useOffer();

  const onSelctorCompnent = props.selectorLayout;

  const isThisModelSelected = modelList.some(
    (model) => model.id === props.model.id && onModelSelection
  );

  const handleOnClick = () => {
    /* console.log(onSelctorCompnent); */
    if (onSelctorCompnent) {
    } else if (!onSelctorCompnent) {
      setModel(props.model);
      navigate(`/models/${props.model.id}`);
    }
  };

  const handleSelect = () => {
    if (onModelSelection && !isThisModelSelected) {
      props.setModelSelectQuantity((prevCounter: number) => prevCounter + 1);
      addModel();
    }
    if (onModelSelection && isThisModelSelected) {
      props.setModelSelectQuantity((prevCounter: number) => prevCounter - 1);
      removeModel();
    }
    /* isThisModelSelected.toggle(); */
  };

  const addModel = () => {
    setModelList((prevList: Model[]) => {
      const finalList: Model[] = [];
      prevList.forEach((model) => {
        finalList.push(model);
      });
      finalList.push(props.model);
      return finalList;
    });
  };

  const removeModel = () => {
    setModelList((prevList: Model[]) => {
      const finalList: Model[] = [];
      prevList.forEach((model) => {
        if (model.id === props.model.id) {
        } else {
          finalList.push(model);
        }
      });
      return finalList;
    });
  };

  const save = (list: Model[]) => {
    const id = offer?.id;
    let finalObj = offer;
    if (list.length > 0) {
      let models_id_array: number[] = [];
      list.forEach((model: Model) => {
        models_id_array.push(model.id);
      });
      /* console.log(models_id_array); */
      finalObj = { ...offer, models_proposed_list: models_id_array };
    } /* 
    console.log(finalObj, id); */
    CTAs.updateOffer(id!, finalObj);
  };

  const removeModelWithCTA = () => {
    const finalList: Model[] = [];
    modelList.forEach((model) => {
      if (model.id === props.model.id) {
      } else {
        finalList.push(model);
      }
    });
    /* console.log(finalList); */
    setModelList(finalList);
    save(finalList);
  };

  useEffect(() => {
    /* console.log(RESPONSES.updateResponse, RESULTS.updateResult);   */
    if (RESPONSES.updateResponse?.ok) {
      props.logMessage.write("subject", "Offer");
      props.logMessage.write("other_text", " has been updated successfully!");
      props.logMessage.write("bgColor", logMsgBgColors.correct);
      const tOffer = offerRemappingFromResult(RESULTS.updateResult.data);
      /* console.log(tOffer); */
      setOffer(tOffer);
    } else if (RESPONSES.updateResponse?.ok === false) {
      props.logMessage.write("subject", "Offer");
      props.logMessage.write("other_text", " could not be updated");
      props.logMessage.write("bgColor", logMsgBgColors.error);
    }
  }, [RESPONSES.updateResponse]);

  return (
    <div
      className="model-card-preview shadow"
      style={{
        width: isMobile ? "100%" : "",
        height: isMobile ? "440px" : "",
        backgroundColor:
          onModelSelection && isThisModelSelected ? "#6788a1" : "",
        cursor: props.shareLayout ? "default" : "",
      }}
      onClick={() =>
        onModelSelection
          ? handleSelect()
          : props.shareLayout
          ? ""
          : handleOnClick()
      }
      onMouseEnter={() => isIconShowUp.setIsToggled(true)}
      onMouseLeave={() => isIconShowUp.setIsToggled(false)}
    >
      {!onSelctorCompnent &&
        onModelSelection &&
        (isMobile ? true : isIconShowUp.isToggled) && (
          <div
            className="model-selector-icon-wrapper"
            style={{
              backgroundColor:
                onModelSelection && isThisModelSelected ? "#6788a1" : "#fff",
            }}
          >
            <img
              className={`model-selector-icon ${
                onModelSelection && isThisModelSelected ? "white" : "black"
              }`}
              src={`${toIcons}/iconly-light-${
                onModelSelection && isThisModelSelected ? "menus" : "plus"
              }.svg`}
              alt=""
            />
          </div>
        )}
      {onSelctorCompnent /* && isIconShowUp.isToggled */ && (
        <div
          className="model-selector-icon-wrapper"
          style={{
            backgroundColor:
              onModelSelection && isThisModelSelected ? "#6788a1" : "#fff",
          }}
          onClick={removeModelWithCTA}
        >
          <img
            className={`model-selector-icon ${
              onModelSelection && isThisModelSelected ? "white" : "black"
            }`}
            src={`${toIcons}/close.svg`}
            alt=""
          />
        </div>
      )}
      <div
        className="model-preview-image"
        style={{
          margin: isMobile ? "24px auto 0" : "",
          backgroundImage: `url(${props.model.profileImageSrc})`,
        }}
      />
      <div className="model-card-info">
        <p
          className="model-card-name"
          style={{
            color: onModelSelection && isThisModelSelected ? "white" : "",
          }}
        >
          {props.model.bio.name} {props.model.bio.surname}
        </p>
        <div className="model-card-specs-box">
          <span className="model-card-spec">
            <img
              className={`model-card-spec-icon ${
                onModelSelection && isThisModelSelected ? "white" : "grey"
              }`}
              src={`${toIcons}/high.svg`}
              alt=""
            />
            <p
              className="model-card-spec-text"
              style={{
                color: onModelSelection && isThisModelSelected ? "white" : "",
              }}
            >
              {props.model.measures.height + "  cm"}
            </p>
          </span>
          <span className="model-card-spec">
            <img
              className={`model-card-spec-icon ${
                onModelSelection && isThisModelSelected ? "white" : "grey"
              }`}
              src={`${toIcons}/measurements.svg`}
              alt=""
            />
            <p
              className="model-card-spec-text"
              style={{
                color: onModelSelection && isThisModelSelected ? "white" : "",
              }}
            >
              {props.model.measures.bust +
                "-" +
                props.model.measures.waist +
                "-" +
                props.model.measures.hips +
                "  cm"}
            </p>
          </span>
        </div>
      </div>
    </div>
  );
};
export default ModelCard;
